module.exports = __webpack_public_path__ + "img/heating-type-02-label-en.asset.cf9e3c0c.svg";